import { filterGlasgowBlueprint } from "@made-people/blueprint-filter/blueprint";

filterGlasgowBlueprint.main.override({
  slots: {
    base: "flex flex-col gap-2 pb-20 lg:h-full lg:m-0 lg:min-w-96 lg:w-component-max-w-sm overflow-y-auto overflow-x-hidden h-[80dvh] max-h-[80dvh] lg:max-h-none",
    filterHeader: "flex justify-between py-2",
    filterHeaderTitle: "text-heading-md lg:text-heading-md font-medium",
    activeFilters: " py-4 flex flex-col gap-3 lg:px-0",
    activeFiltersList: "flex gap-2 flex-wrap",
    filterOptions: "overflow-hidden transition-all duration-300 flex flex-col",
    filterOptionIndicator:
      "w-4 h-4 mr-2 data-[is-selected=true]:bg-black border border-black rounded-sm",
    filterOption:
      "py-2 flex items-center gap-1 text-label-md [&>div]:w-fit [&>div]:pl-0",
    filterSubheading: "text-label-md font-bold text-black pt-4 pb-2",
    filterGroupedContainer: "flex flex-col gap-4",
    filterGroupedSection: "flex flex-col gap-2 last:pb-3",
    filterGroupedGrid: "flex flex-wrap gap-3",
    filterGroupedButton:
      "w-12 h-12 flex items-center justify-center rounded-full border border-gray-300 text-label-md cursor-pointer hover:border-black data-[selected=true]:bg-black data-[selected=true]:text-white data-[selected=true]:border-black transition-colors",
    bottomRow:
      "flex justify-between items-center gap-2 absolute left-0 right-0 bottom-0 z-10 bg-white p-4 border-t border-gray-200 border-solid first:[&>button]:hidden",
  },
});

filterGlasgowBlueprint.accordion.override({
  slots: {
    base: "lg:max-h-[calc(100vh-10rem)] lg:overflow-y-scroll",
    trigger:
      "flex items-center justify-between w-full py-4 cursor-pointer group/facet-trigger text-heading-sm text-left gap-4 hover:bg-gray-50",
    content: "pb-3",
    item: "border-b border-gray-200 first:border-t",
    header: "",
    headerWrapper: "flex items-center gap-2",
    headerLeftImage: "w-5 h-5",
    iconOpen:
      "group-data-[state=open]:rotate-180 group-data-[state=closed]:rotate-0 transition-transform w-4 h-4",
    iconClose: "hidden",
  },
});
